import React, { Component } from 'react';
import './PrivacyPolicy.css'

export default class TermsScreen extends Component {
  render() {
    window.scrollto({ top: 0, behavior: 'smooth' });

    return (
      <div className='padding-left'>
        <h2 className="section-title">terms and conditions</h2>
        <hr/>
        <br/>
        <div className="section-text-left">
          <div className="terms-and-conditions">
            <div>
              <div>
                <strong>ОБЩИ УСЛОВИЯ ЗА ИЗПОЛЗВАНЕ НА ИНТЕРНЕТ САЙТ shop.kypbn.com</strong>
                <hr/>
              </div>
              <br/>

              <div>
                Настоящите ОБЩИ УСЛОВИЯ уреждат взаимоотношенията между „ЕРШАЛ ЕООД”,
                от една страна, и Потребителите на интернет страници и услуги, намиращи се на домейн shop.kypbn.com (наричани по-долу Потребители), от друга.
              </div>
              <br/>

              <div>
                Моля, прочетете изцяло публикуваните ОБЩИ УСЛОВИЯ преди да използвате информационните и търговски услуги, предлагани от сайта shop.kypbn.com (наричани за краткост Услуги). С визуализирането на shop.kypbn.com всеки Потребител автоматично се задължава да спазва условията, описани по-долу.<br/>
              </div>
              <br/>

              <div>
                Ако НЕ ПРИЕМАТЕ тези условия, моля, не използвайте този уеб сайт. ЕРШАЛ ЕООД си запазва правото да променя условията по всяко време, без предварително известие, като променените условия ще бъдат публикувани в сайта.
              </div>
              <br/>

              <div>
                „ЕРШАЛ ЕООД” с ЕИК: 205219797 е регистриран с постоянен адрес Враца, ул.Кетхудов №33, вх.А, ап.8<br/>
                Електронен адрес за кореспонденция: kypbn@gmail.com<br/>
                Tелефон: 0877553516<br/>
              </div>
              <br/>

              <div>
                „ЕРШАЛ ЕООД” е регистрирано като администратор на лични данни и притежава Удостоверение за администратор на лични данни № <span>434086</span>.
              </div>
              <br/>

              <div>
                Настоящият документ съдържа информация за дейността на „ЕРШАЛ ЕООД” и общите условия за ползване на услугите, предоставяни от "ЕРШАЛ ЕООД”, като уреждат отношенията между нас и всеки един от потребители ни.
              </div>
              <br/>

            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ПРЕДОСТАВЯНИ УСЛУГИ</strong>
              </div>
              <hr/>
              <div>
                Чл. 1 Услугите, предоставяна от „ЕРШАЛ ЕООД” на Потребителя, представляват услуги на информационното общество по смисъла на Закона за електронната търговия.
              </div>

              <div>
              Чл. 2. „ЕРШАЛ ЕООД” e електронен магазин, достъпен на сайта shop.kypbn.com , чрез който Потребителите имат възможност да сключват договори за покупко-продажба и доставка на предлаганите от ЕРШАЛ ЕООД” стоки.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ИДЕНТИФИКАЦИЯ</strong>
              </div>
              <hr/>
              <div>
              Чл. 3 (1) „ЕРШАЛ ЕООД” идентифицира Потребителите на сайта чрез съхранение на лог-файлове на сървъра на shop.kypbn.com и на IP адреса на Потребителя.
              </div>
              <div>(2) „ЕРШАЛ ЕООД” има право да събира и използва информация относно Потребителите след извършената от тях идентификация. Информацията, чрез която лицето може да бъде идентифицирано, може да включва име, фамилия, дата на раждане, пол, адрес, телефон, както и всяка друга информация, която лицето предоставя доброволно при идентификацията. Информацията включва и всяка друга, която Потребителят въвежда, използва или предоставя при ползване Услугите, предоставяни от „ЕРШАЛ ЕООД”.
              </div>
              <br/>
              <div>
                Чл. 4 (1) „ЕРШАЛ ЕООД” полага дължимата грижа и отговаря за защита на информацията за Потребителя, станала му известна по повод на идентификацията- предмет на настоящите Общи условия, освен в случаите на непреодолима сила, случайно събитие или злоумишлени действия на трети лица.
              </div>
              <div>
                (2). В идентификационната форма, попълвана от Потребителя, „ЕРШАЛ ЕООД” обозначава задължителния или доброволния характер на предоставяне на данните и последиците от отказ за предоставянето им. С изразяване на съгласие с настоящите Общи условия Потребителят се съгласява информацията за него да бъде обработвана по предвидения в тях ред.
              </div>
              <div>
                (3) Ограниченията по ал. 1 не се прилагат в случай, че за “ЕРШАЛ ЕООД” възникне задължение да предостави личната информация за Потребителя на съответните компетентни държавни органи съгласно действащото законодателство.
              </div>
              <br/>

              <div>
                Чл. 5 (1) „ЕРШАЛ ЕООД” събира и използва информацията по чл. 4 за целите, предвидени в настоящите Общи условия, както и за предлагане на нови стоки и/или услуги на Потребителя (безплатни или платени). Описаните цели, за които се използва информацията, не са изчерпателно изброени и не пораждат задължения за „ЕРШАЛ ЕООД”.
              </div>
              <div>
                (2) С приемането на настоящите Общи условия Потребителят се съгласява с обработването на личните му данни за целите на директния маркетинг.
              </div>
              <br/>

              <div>
                Чл. 6 (1) Потребителят може да се идентифицира като попълни съответната електронна форма за идентификация, достъпна в реално време (on-line) в Интернет на сайта на „ЕРШАЛ ЕООД”, да изрази съгласие с настоящите Общи условия и да декларира, че е правоспособен.
              </div>
              <div>
                (2) При идентификацията Потребителят извършва електронно изявление по смисъла на Закона за електронния документ и електронния подпис, с което декларира, че е запознат с настоящите Общи условия, приема ги и се задължава да ги спазва. Със записването му на съответен носител в сървъра на „ЕРШАЛ ЕООД”, чрез общоприет стандарт за преобразуване по технически начин, правещ възможно неговото възпроизвеждане, електронното изявление придобива качеството на електронен документ по смисъла на цитирания закон. „ЕРШАЛ ЕООД” може да съхранява в лог-файлове на своя сървър IP адреса на Потребителя, както и всяка друга информация, необходима за идентифицирането му и възпроизвеждане на електронното му изявление за приемане на Общите условия в случай на възникване на правен спор. Текстът на настоящите Общи условия е достъпен в Интернет на сайта на “ЕРШАЛ ЕООД” по начин, който позволява неговото съхраняване и възпроизвеждане.
              </div>
              <div>
                (3) При попълване на заявлението за идентификация Потребителят е длъжeн да предостави пълни и верни данни относно самоличността (за физическите лица), правния статут (за юридическите лица) и другите изискуеми от електронната форма на „ЕРШАЛ ЕООД” данни. Потребителят декларира, че е съгласен да предостави така изискваните лични данни, при което гарантира, че данните, които предоставя в процеса на идентификацията, са верни, пълни и точни. В случай на предоставяне на неверни данни “ЕРШАЛ ЕООД” има право да прекрати или спре незабавно и без предизвестие предоставянето на услугите.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ПОРЪЧКА</strong>
              </div>
              <hr/>

              <div>
                Чл. 7 (1) Потребителите използват интерфейса на уебсайта на „ЕРШАЛ ЕООД”, за да сключват договори за покупко-продажба на предлаганите от „ЕРШАЛ ЕООД” стоки в електронния магазин.
              </div>
              <div>
                (2) Договорът за покупко-продажба на стока се счита за сключен от момента на потвърждаването на поръчката от „ЕРШАЛ ЕООД”.
              </div>
              <br/>

              <div>
                Чл. 8 (1) За да заяви поръчка, Потребителят е необходимо да се идентифицира съобразно реда и условията, описани в настоящите общи условия.
              </div>
              <div>
                (2) След избиране на една или повече стоки, предлагани на уебсайта на „ЕРШАЛ ЕООД”, Потребителят трябва да добави същите в списъка си със стоки за покупка („кошница”, „количка”, „cart“).
              </div>
              <div>
                (3) Необходимо е Потребителят да предостави данни за извършване на доставката и да избере способ и момент на плащане на цената, след което да потвърди поръчката чрез интерфейса на електронния магазин.
              </div>
              <div>
                (4) При извършване на поръчка, Потребителят получава потвърждение по имейл, че поръчката му е приета.
              </div>
              <div>
                Потвърждаването на Общите условия е необходимо и задължително условие за всяка поръчка на всеки Потребител и за сключването на договора между него и „ЕРШАЛ ЕООД”. С натискане на виртуален бутон с текст "Accept" или с друг аналогичен текст, се счита, че сте запознати с Общите условия и се задължавате да ги спазвате.
              </div>
              <div>
                (5) При посочени неверен или сгрешен адрес, лице за контакти и/или телефон при подаване на заявката ЕРШАЛ ЕООД чрез “shop.kypbn.com” не е обвързан от каквото и да е задължение за изпълнение на поръчката.<br/>
                (6) Договорът с Клиента се счита за сключен след приемане от ЕРШАЛ ЕООД чрез “shop.kypbn.com” на заявлението за покупка попълнено правилно от Клиента в процеса на поръчка.<br/>
                (7) ЕРШАЛ ЕООД чрез “shop.kypbn.com” се задължава след получаване на заявление от Клиента, да му достави желаната стока или да информира Клиента за др. обстоятелства, относно заявката му.<br/>
                (8) ЕРШАЛ ЕООД не носи отговорност, ако Клиентът е посочил неверни и/или непълни данни в направена поръчка на адрес "shop.kypbn.com”.<br/>
                (9) ЕРШАЛ ЕООД не носи отговорност за допуснати неточности в публикуваната на сайта информация. Възможни са корекции на цените, както и промяна в дизайна на продуктите.<br/>
                (10) Публикуваната на сайта информация за размери и съответствия трябва да се тълкува като ориентировъчна. ЕРШАЛ ЕООД допуска наличието на разминавания между обявените и действителните размери, за което не носи отговорност.<br/>
              </div>
            </div>

            <br/>

            <div>
              <div>
                <strong>ЦЕНИ</strong>
              </div>
              <hr/>

              <div>
                Чл. 9 (1) Цените на продуктите, предлагани в онлайн магазина, са тези, посочени на уебсайта на „ЕРШАЛ ЕООД” към момента на извършване на поръчка, освен в случаи на очевидна грешка.
              </div>
              <div>
                (2) Цените на продуктите са посочени във валутата, посочена на уебсайта на „ЕРШАЛ ЕООД”, и включват ДДС, в случаите, в които е предвидено начисляването му.
              </div>
              <br/>

              <div>
                Чл. 10 „ЕРШАЛ ЕООД” си запазва правото да променя по всяко време и без предизвестие цените на предлаганите в онлайн магазина продукти, като такива промени няма да засягат вече извършени поръчки.
              </div>
              <br/>

              <div>
                Чл. 11 (1) „ЕРШАЛ ЕООД” може да предоставя отстъпки за продуктите, предлагани в онлайн магазина, съгласно българското законодателство и правила, определени от „ЕРШАЛ ЕООД”. Правилата, приложими за такива отстъпки, са налични на мястото, където е показана отстъпката. Отстъпки могат да се предоставят под различни форми (напр. промоции, отстъпки за лоялност, предоставяни индивидуално, на случаен принцип или в резултат на участие в състезание или клиентско проучване).
              </div>
              <div>
                (2) Различните видове отстъпки не могат да се комбинират при поръчка и закупуване на една и съща стока.
              </div>
              <br/>

              <div>
                ЕРШАЛ ЕООД не носи отговорност за допуснати неточности в публикуваната на сайта информация. Възможни са корекции на цените, както и промяна в дизайна на продуктите.<br/>
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ПЛАЩАНЕ</strong>
              </div>
              <hr/>

              <div>
                Чл. 12 Когато Потребителят връща продукт с правото на възстановяване на заплатената сума поради каквато и да било причина, цената, обект на възстановяване, се намалява със стойността на получената отстъпка, приложена върху продукта, и само действително платената сума подлежи на възстановяване.
              </div>
              <br/>

              <div>
                Чл. 13 (1) Потребителят може да заплати цената на поръчаните стоки като използва по свой избор една от изброените на уебсайта възможности. На shop.kypbn.com е възможно плащане чрез наложен платеж.
              </div>
              <div>
                (2) Ако Потребителят избере опцията за доставка с куриер и плащане с наложен платеж, той трябва да заплати цената на поръчаните артикули заедно с цената за доставка на куриера при получаването на стоката.
              </div>
              <br/>

              <div>
                Чл. 14 Ако Потребителят избере метод на плащане, включващ трета страна - доставчик на платежни услуги, Потребителят може да бъдете обвързан от разпоредбите и условията и/или таксите на такава трета страна.
              </div>
              <br/>

              <div>
                Чл. 15 „ЕРШАЛ ЕООД” не носи отговорност, ако даден метод плащане, включващ трета страна - доставчик на платежни услуги, не е наличен или по друг начин не функционира поради причини, които не могат да бъдат вменени във вина на „ЕРШАЛ ЕООД”.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ДОСТАВКА</strong>
              </div>
              <hr/>

              <div>
                Чл. 16 (1) Доставката на поръчаните стоки се осъществява чрез куриер (като Еконт) за поръчки в рамките на България и чрез Български Пощи за поръчки извън България до посочен от Потребителя офис или адрес за доставка. Доставката е за сметка на Потребителя, освен ако противното не е изрично указано на shop.kypbn.com.
              </div>
              <div>
                (2) Преди изпращане на поръчаната стока, „ЕРШАЛ ЕООД” има право да се свърже с Потребителя на посочения от него телефон, с цел уточняване на детайли за поръчката и/или доставката.
              </div>
              <div>
                (3) "ЕРШАЛ EООД" не носи отговорност при загуба или увреждане на стоката при доставка.
              </div>
              <div>
                (4) „ЕРШАЛ ЕООД“ не носи отговорност за неизпълнение на поръчка в случаите, когато Потребителят е посочил неверни, непълни и/или неточни лични данни, включително, когато е посочил непълен, неточен или фиктивен адрес или телефон.
              </div>
              <div>
                (5) В случаите, когато е уговорено предварително плащане, поръчката се изпраща 5-7 дни след получаване на плащането. Ако Потребителят иска поръчката му да пристигне преди определена дата, той изпраща запитване дали това е възможно.
              </div>
              <br/>

              <div>
                Чл. 17 Доставката се извършва в сроковете, описани под всяка опция за доставка в интерфейсния модул за поръчка. При извънредни обстоятелства „ЕРШАЛ ЕООД” си запазва правото да удължава срока за доставка, като своевременно информира за това Потребителя.
              </div>
              <br/>

              <div>
                Чл. 18 (1) Поръчаните стоки се доставят срещу подпис, като по-големите пратки (по преценка на куриера) се доставят до входа на сградата.
              </div>
              <div>
                (2) Потребителят е длъжен да прегледа стоката в момента на доставката ѝ и да уведоми незабавно при установени несъответствия, липси и повреди. Ако Потребителят не стори това, се приема, че доставката е приета без възражения.
              </div>
              <br/>

              <div>
                Чл. 19 (1) При невъзможност или затруднение за връчване лично на адресата, пратките се връчват както следва:
              </div>
              <div>
                а) за служебен адрес – на лице с месторабота на адреса, като се отбелязва името на лицето, получило пратката;
              </div>
              <div>
                б) за домашен адрес – на член на домакинството, като се отбелязва името на лицето, получило пратката.
              </div>
              <div>
                (2) При невъзможност за връчване на пратката, настъпила не по вина на „ЕРШАЛ ЕООД” или куриера, лицето, извършващо доставката, се обажда на посочения от Потребителя телефон за контакт, за да бъде уточнено от кой офис на куриера Потребителят може да получи доставката.
              </div>
              <div>
                (3) При невъзможност да се установи контакт с Потребителя, договорът за продажба от разстояние автоматично се разваля, като „ЕРШАЛ ЕООД” се освобождава от задължението си за доставка на поръчаните стоки.
              </div>
              <br/>

              <div>
                Чл. 20 (1) При извършване на международни доставки, приложими са правилата за доставка и получаване на пратки на съответната национална пощенска служба, както и на съответното национално законодателство на държавата, в която се намира получателят на стоките.
              </div>
              <div>
                (2) Всички импортни такси при внасянето на стоката са за сметка на Потребителя. Потребителят не може да иска възстановяване на цената, ако е отказал да плати импортните такси или да получи пратката.
              </div>
              <div>
                (3) Международни доставки се осъществяват с „Български пощи“.
              </div>
              <br/>

              <div>
                Чл. 21 „ЕРШАЛ ЕООД” си запазва правото да променя наличните методи на доставка и плащане и/или условията по тях по всяко време чрез публикуване на наличните методи на доставка и плащане на уебсайта без друго известие.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ОТКАЗ ОТ ДОГОВОРА И ЗАМЯНА</strong>
              </div>
              <hr/>

              <div>
                Чл. 22 (1) Потребителят има право да се откаже от договора без да посочва причина, без да дължи обезщетение или неустойка в 14-дневен срок, считано от датата на приемане на стоките от Потребителя или от трето лице.
              </div>
              <div>
                (2) За да упражни правото си по настоящата клауза, Потребителят трябва да уведоми недвусмислено „ЕРШАЛ ЕООД” за решението си да се откаже от договора, като индивидуализира стоките, които желае да върне, чрез предоставяне на всички данни за осъществената поръчка и доставка, включително, но не само: съдържание и стойност на поръчката, данни на лицето, направило поръчката, данни на лицето, приело доставката, и дата на доставката.
              </div>
              <div>
                (3) „ЕРШАЛ ЕООД“ публикува на сайта си формуляр за упражняване правото на отказ от договора.
              </div>
              <div>
                (4) За упражняване правото на отказ „ЕРШАЛ ЕООД“ предоставя на потребителя възможност за избор да попълни и да изпрати по електронен път чрез интернет страницата стандартния формуляр за отказ или друго недвусмислено заявление. В тези случаи „ЕРШАЛ ЕООД“ незабавно изпраща на потребителя потвърждение за получаване на отказа му на траен носител.
              </div>
              <div>
                (5) Потребителят е длъжен да върне стоките за своя сметка задължително заедно с касовата бележка и фактурата, ако има такава, като ги предаде на „ЕРШАЛ ЕООД” или на упълномощено от последното лице, в срок от 14 дни от датата, на която Потребителят е упражнил правото си на отказ от договора.
              </div>
              <div>
                (6) „ЕРШАЛ ЕООД“ има право да отложи възстановяването на плащанията до получаване на стоките обратно или докато не бъде представено доказателство, че е стоките са изпратени обратно, в зависимост от това, кое от двете събития е настъпило по-рано.
              </div>
              <div>
                (7) В случай че Потребителят не изпълни задължението си по алинея 5, без да уведоми „ЕРШАЛ ЕООД” за забавянето и без да предостави уважителна причина за същото, се счита, че той е оттеглил изявлението си за упражняване на отказ от договора.
              </div>
              <br/>

              <div>
                Чл. 23 (1) Потребителят няма право да се откаже от договора в случай че предмет на същия са: продукти, направени съгласно индивидуални спецификации или явно персонализирани; продукти, които могат да влошават качеството си или продукти с кратък срок на годност; продукти, които не могат да бъдат върнати поради причини, свързани със защита на здравето или хигиената, и които са разпечатани след доставка; запечатани звуко- и видеозаписи или запечатан компютърен софтуер, които са разпечатани след доставка.
              </div>
              <div>
                (2) В случай, че при получаване на върнатите стоки бъде установено, че същите са с разпечатана фабрична опаковка (когато се касае за продукти, които не могат да бъдат върнати поради причини, свързани със защита на здравето или хигиената и за запечатани звуко- и видеозаписи или запечатан компютърен софтуер), както и когато получената стока е ползвана, прана или по друг начин употребявана, „ЕРШАЛ ЕООД” няма да има задължение да възстанови на Потребителя заплатената цена.
              </div>
              <br/>

              <div>
                Чл. 24 „ЕРШАЛ ЕООД” възстановява на Потребителя заплатената от него цена за върнатите стоки.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>РЕКЛАМАЦИЯ</strong>
              </div>
              <hr/>

              <div>
                Чл. 25 (1) Потребителят има право на рекламация за всяко несъответствие на стоката с договореното/поръчаното, когато след доставката, са открити несъответствия с договора за продажба.
              </div>
              <div>
                (2) Потребителят има право да предяви рекламация на стоката, независимо от това дали производителят или търговецът е предоставил търговска гаранция на стоката или услугата.
              </div>
              <div>
                (3) Когато удовлетворяването на рекламацията се извършва чрез замяна на стоката с друга, съответстваща на договореното, „ЕРШАЛ ЕООД“ ще запази на потребителя първоначалните гаранционни условия.
              </div>
              <div>
                (4) При предявяване на рекламацията на стока потребителят може да претендира за възстановяване на заплатената сума, за заменяне на стоката с друга, съответстваща на договореното или за отбив от цената.
              </div>
              <div>
                (5) Рекламацията се подава устно на посочения от „ЕРШАЛ ЕООД“ телефон или писмено чрез, посочения имейл, по поща или подадена до адреса на дружеството.
              </div>
              <div>
                (6). При предявяване на рекламация потребителят посочва предмета на рекламацията, предпочитания от него начин за удовлетворяване на рекламацията, съответно размера на претендираната сума, и адрес, телефон и email за контакт.
              </div>
              <br/>

              <div>
                4.3. При подаване на рекламация потребителят задължително следва да приложи и документите, на които се основава претенцията, а именно:
              </div>

              <div>
                1. касова бележка или фактура;
              </div>
              <div>
                2. протоколи, актове или други документи, установяващи несъответствието на стоката или услугата с договореното;
              </div>
              <div>
                3. други документи, установяващи претенцията по основание и размер.
              </div>
              <br/>

              <div>
                (7) Рекламацията на потребителска стока може да се предяви до две години от доставката на стоката, но не по-късно от два месеца от установяване на несъответствието с договореното, както и след изтичането и на срока на годност.
              </div>
              <div>
                (8). Срокът спира да тече през времето, необходимо за постигане на споразумение между продавача и потребителя за решаване на спора.
              </div>
              <div>
                (9) Ако “ЕРШАЛ ЕООД“ е предоставил търговска гаранция на стоката и срокът на гаранцията е по-дълъг от сроковете за предявяване на рекламацията по ал. 1, рекламацията може да се предяви до изтичането на срока на търговската гаранция.
              </div>
              <div>
                (10) Предявяването на рекламация не е пречка за предявяване на иск.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ГАРАНЦИИ</strong>
              </div>
              <hr/>

              <div>
                Чл. 26 Потребителите се ползва от предвидените в Закона за защита на потребителите гаранционни срокове.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ЕДНОСТРАННО ПРЕКРАТЯВАНЕ</strong>
              </div>
              <hr/>

              <div>
                Чл. 27 „ЕРШАЛ ЕООД” има право по свое усмотрение, без да отправя предизвестие да прекрати едностранно договора, в случай че установи, че предоставяните услуги се използват в нарушение на настоящите общи условия, законодателството в Република България и общоприетите нравствени норми.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ИНТЕЛЕКТУАЛНА СОБСТВЕНОСТ</strong>
              </div>
              <hr/>

              <div>
                Чл. 28 (1) Правата на интелектуална собственост върху всички материали и ресурси, разположени на уебсайта на „ЕРШАЛ ЕООД” (включително наличните бази данни), са обект на закрила по Закона за авторското право и сродните права, принадлежат на „ЕРШАЛ ЕООД” или на съответно указаното лице, преотстъпило правото на ползване на „ЕРШАЛ ЕООД”, и не могат да бъдат използвани в нарушение на действащото законодателство.
              </div>
              <div>
                (2) Правото на достъп на Потребителя не включва правото да се използва, копира или възпроизвежда информация, представляваща обект на интелектуална собственост, освен ако се касае за незначителен по обем информация, предназначена за лично ползване, при условие че не се увреждат неоправдано законните интереси на авторите или другите носители на права на интелектуална собственост и в случай че копирането или възпроизвеждането се извършват с нетърговска цел.
              </div>
              <div>
                (3) При копиране или възпроизвеждане на информация вън от допустимото, съгласно предходната алинея, както и при всяко друго нарушение на правата на интелектуална собственост върху ресурсите на „ЕРШАЛ ЕООД”, „ЕРШАЛ ЕООД” има правото да претендира обезщетение и за претърпените преки и косвени вреди в пълен размер.
              </div>
              <div>
                (4) Потребителят се задължава при ползване на предоставения му достъп до предлагани от „ЕРШАЛ ЕООД” услуги: да спазва българското законодателство, настоящите Общи условия, Интернет етиката, правилата на морала и добрите нрави; да не накърнява доброто име на другиго и да не призовава към насилствена промяна на конституционно установения ред, към извършване на престъпление, към насилие над личността или към разпалване на расова, национална, етническа или религиозна вражда, да не проповядва фашистка или друга антидемократична идеология, да не нарушава чужди имуществени или неимуществени права, включително право на интелектуална собственост; да уведомява незабавно „ЕРШАЛ ЕООД” за всеки случай на извършено или открито нарушение; да не се намесва в правилното действие на системата, включително, но не само, да не осуетява процедурата по идентификация на друг Потребител, да не осъществява достъп извън предоставения, да не накърнява или възпрепятства наличността, надеждността или качеството на предоставения достъп, както и да не го използва по начин, предизвикващ отказ от използването му; да не извлича чрез технически средства или по технически начин информационни ресурси или части от информационни ресурси, принадлежащи към базите данни, разположени на уебсайта на „ЕРШАЛ ЕООД” и по този начин да не създава собствена база данни в електронен или друг вид; да не се представя за друго лице или по друг начин да заблуждава трети лица относно самоличността си или принадлежността си към определена група хора; да не извършва злоумишлени действия по смисъла на настоящите Общи условия.
              </div>
              <div>
                (5) Освен в случаите, когато е изрично уговорено, Потребителят не може да възпроизвежда, променя, заличава, публикува, разпространява и разгласява по друг начин информационните ресурси, публикувани на уебсайта на „ЕРШАЛ ЕООД”.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ПРЕКРАТЯВАНЕ И РАЗВАЛЯНЕ НА ДОГОВОРА</strong>
              </div>
              <hr/>

              <div>
                Чл. 29 (1) Освен в случаите, предвидени в настоящите Общи условия, договорът между страните се прекратява и при преустановяване на дейността на „ЕРШАЛ ЕООД” или прекратяване поддържането на уебсайта му.
              </div>
              <div>
                (2) Потребителят има право по всяко време по своя собствена преценка да спре ползването на предоставяните от „ЕРШАЛ ЕООД” услуги.
              </div>
              <br/>

              <div>
                Чл. 30 Извън посочените по-горе случаи всяка от страните може да развали настоящия договор с отправяне на едноседмично предизвестие до другата страна в случай на неизпълнение на задълженията по договора.
              </div>
              <br/>

              <div>
                Чл. 31 Писмената форма на договора се счита спазена с изпращане на съобщение на електронна поща (e-mail), натискане на електронен бутон на страница със съдържание, което се попълва или избира от Потребителя или отбелязване в поле (чек бокс) в уебсайта и др. подобни, доколкото изявлението е записано технически по начин, който дава възможност да бъде възпроизведено.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ОРГАНИ РЕГУЛИРАЩ ДЕЙНОСТТА</strong>
              </div>
              <hr/>

              <div>
                Чл. 32 Органите, регулиращи дейността на „ЕРШАЛ ЕООД“ са Комисия за защита на потребителя /КЗП/ и Комисия за защита на личните данни (КЗЛД), със следните координати:
              </div>
              <br/>
              <div>
                За КЗП:
                <br/>
                Уебсайт: https://kzp.bg/kontakti
                <br/>
                тел: 0700 111 22
                <br/>
                email: info@kzp.bg
                <br/>
                адрес: гр. София, пл. Славейков, №4А, ет. 3, 4 и 6
                <br/>
                За КЗЛД:
                <br/>
                Уебсайт: https://www.cpdp.bg/
                <br/>
                тел: 02/91-53-518
                <br/>
                email: kzld@cpdp.bg
                <br/>
                адрес: София 1592, бул. „Проф. Цветан Лазаров” № 2
                <br/>
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>СПАСИТЕЛНА КЛАУЗА</strong>
              </div>
              <hr/>

              <div>
                Чл. 33 Страните декларират, че, в случай че някоя/и от клаузите по настоящите Общи условия се окаже/окажат недействителна/и, това няма да влече недействителност на целия договор или на други негови части. Недействителната клауза ще бъде заместена от повелителните норми на закона или установената практика.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>ИЗМЕНЕНИЕ НА ОБЩИТЕ УСЛОВИЯ</strong>
              </div>
              <hr/>

              <div>
                Чл. 34 (1) „ЕРШАЛ ЕООД” се задължава да уведоми Потребителите за всяко изменение в настоящите общите условия в 7-дневен срок от настъпването на това обстоятелство на посочения от Потребителя имейл адрес.
              </div>
              <div>
                (2) Когато не е съгласен с измененията в общите условия, Потребителят има право да се откаже от договора, без да посочва причина и без да дължи обезщетение или неустойка. За да упражни това си право, Потребителят следва да уведоми „ЕРШАЛ ЕООД” в срок от един месец от получаването на съобщението по предходната алинея.
              </div>
              <div>
                (3) В случай че Потребителят не упражни правото си да се откаже от договора по реда, уреден в настоящите общи условия, се счита, че изменението е прието от Потребителя без възражения.
              </div>
            </div>
            <br/>
            <br/>


            <div>
              <div>
                <strong>ПРИЛОЖИМО ПРАВО</strong>
              </div>
              <hr/>

              <div>
                Чл. 35 По всички неуредени от настоящите Общи условия въпроси се прилагат разпоредбите на действащото законодателство на Република България.
              </div>
            </div>
            <br/>
            <br/>

            <div>
              <div>
                <strong>СТАНДАРТЕН ФОРМУЛЯР ЗА УПРАЖНЯВАНЕ ПРАВОТО НА ОТКАЗ ОТ ДОГОВОРА</strong>
              </div>
              <hr/>
              <div>
                Изтеглете формуляр от <strong><a href="{{ url_for('static', filename='media/docs/order_rejection.docx') }}">тук</a></strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
